/* eslint-disable no-param-reassign */
import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from 'react';

import { Button as MaterialButton, InputLabel } from '@material-ui/core';
import DataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

import { FormHandles } from '@unform/core';
import Input from '../../Input';
import {
  Container,
  TabAdicionais,
  TabMontagem,
  TabMontagemBottom,
  TabMontagemTop,
  Title,
} from './style';
import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import CheckBox from '../../CheckBox';
import { Produto } from '../../../pages/Cadastros/Produtos';
import DialogAdicionais from './DialogAdicionais';
import DialogDeleteAdicionais from './DialogDeleteAdicionais';
import { MontagemContext } from '../../../contexts/MontagemContext';
import { Montagem } from '../DialogInsumos';
import { CdProdPaiContext } from '../../../contexts/CdProdPaiContext';

export interface BaixaAdicionais {
  cd: string;
  cd_prod: string;
  cd_prod_pai: string;
  nm: string;
  qtd: string;
  preco_custo: string;
  vl: string;
  tipo: string;
  ordem: string;
  qtd_min: string;
  qtd_max: string;
  qtd_inicial: string;
}

const defaultColumnProperties = {
  resizable: true,
};

const columns = [
  {
    key: 'cd',
    name: 'CD',
    filterable: true,
  },
  {
    key: 'nm',
    name: 'Nome',
    filterable: true,
    width: 170,
  },
  {
    key: 'qtd',
    name: 'Qtd',
    filterable: true,
  },
  {
    key: 'preco_custo',
    name: 'Custo',
    filterable: true,
  },
  {
    key: 'vl',
    name: 'Acres/Desc',
    filterable: true,
  },
  {
    key: 'tipo',
    name: 'Tipo',
    filterable: true,
  },
  {
    key: 'ordem',
    name: 'Ordem',
    filterable: true,
  },
  {
    key: 'qtd_min',
    name: 'Qtd Min.',
    filterable: true,
  },
  {
    key: 'qtd_max',
    name: 'Qtd Máx.',
    filterable: true,
  },
  {
    key: 'qtd_inicial',
    name: 'Qtd Inicial',
    filterable: true,
  },
  {
    key: 'acoes',
    name: 'Ações',
  },
].map((c) => ({ ...c, ...defaultColumnProperties }));
const selectors = Data.Selectors;
function getRows(rows: any, filters: any) {
  return selectors.getRows({ rows, filters });
}
const handleFilterChange = (filter: any) => (filters: any) => {
  const newFilters = { ...filters };
  if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
  } else {
    delete newFilters[filter.column.key];
  }
  return newFilters;
};
const EmptyRowsView = () => {
  const message = 'Ops, não há dados disponíveis...';
  return (
    <div style={{ textAlign: 'center', padding: '100px' }}>
      <h3>{message}</h3>
    </div>
  );
};

const TabInsumos: React.FC = () => {
  const [filters, setFilters] = useState({});
  const [cdBaixaAdicional, setCdBaixaAdicional] = useState('');
  const [cdBaixaAdicionalDelete, setCdBaixaAdicionalDelete] = useState('');
  const [listaBaixaAdicionais, setListaBaixaAdicionais] = useState({});
  const [listaProdutos, setListaProdutos] = useState([] as any);
  const [typeRequest, setTypeRequest] = useState('');
  /*   const [currentMontagens, setCurrentMontagens] = useState<Montagem[]>(
    [] as any,
  ); */
  const formRef = useRef<FormHandles>(null);
  const [openInsertBaixaAdicionais, setOpenInsertBaixaAdicionais] = useState(
    false,
  );
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const { addToast } = useToast();
  const {
    montagens,
    setMontagens,
    addMontagem,
    setAddMontagem,
    handleClose,
  } = useContext(MontagemContext);

  const { cd_prod_pai } = useContext(CdProdPaiContext);

  const filteredRows = getRows(listaBaixaAdicionais, filters);

  const handleOpenInsertBaixaAdicionais = useCallback(() => {
    setOpenInsertBaixaAdicionais(true);
    setTypeRequest('create');
  }, []);
  const changeMontagem = useCallback(
    (text, field) => {
      setMontagens(
        montagens.map((montagem) => {
          if (montagem.focus) {
            if (field == 'nome') {
              montagem.nm = text;
            } else if (field == 'titulo') {
              montagem.titulo = text;
            } else if (field == 'qtd_min') {
              montagem.qtd_min = text;
            } else if (field == 'qtd_max') {
              montagem.qtd_max = text;
            } else if (field == 'ordem') {
              montagem.ordem = text;
            }
          }
          return montagem;
        }),
      );
    },
    [montagens, setMontagens],
  );
  const getProdutos = useCallback(() => {
    api
      .get<Produto[]>('produtos')
      .then((response) => {
        const itemsFormatted = [] as Array<any>;
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
        response.data.forEach((produto) => {
          itemsFormatted.push({
            ...produto,
            vl: formatter.format(parseFloat(produto.vl)),
          });
        });
        setListaProdutos(itemsFormatted);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar os produtos: ${error}`,
        });
      });
  }, [addToast]);

  const populaTabela = useCallback(() => {
    const mont: Montagem[] = montagens.filter((montagem) => montagem.focus);
    api
      .get<BaixaAdicionais[]>(
        `baixa_adicionais/baixa_montagem/${
          mont.length > 0 && mont[0].cd
        }/?cd_prod_pai=${cd_prod_pai}`,
      )
      .then((response) => {
        setListaBaixaAdicionais(response.data);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Ops, ocorreu algum erro ao listar os produtos: ${error}`,
        });
      });
  }, [addToast, cd_prod_pai, montagens]);

  const handleSubmit = useCallback(async () => {
    const response = await api.put('montagem', {
      montagens: montagens.filter((montagem) => montagem.cd >= 0),
    });

    if (response.status === 200) {
      populaTabela();
      handleClose();
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: `Insumos cadastrados com sucesso.`,
      });
    }
  }, [addToast, handleClose, montagens, populaTabela]);
  const getCellActions = useCallback((column: any, row: any) => {
    const cellActions: { [index: string]: any } = {
      acoes: [
        {
          icon: (
            <span className="remover">
              <FiTrash2 />
            </span>
          ),
          callback: () => {
            setOpenConfirmation(true);
            setCdBaixaAdicionalDelete(row.cd);
          },
        },
        {
          icon: (
            <span className="edit">
              <FiEdit />
            </span>
          ),
          callback: () => {
            /*  changeTabs('geral'); */
            setCdBaixaAdicional(row.cd);
            setTypeRequest('update');
          },
        },
      ],
    };
    return cellActions[column.key];
  }, []);

  useEffect(() => {
    populaTabela();
  }, [montagens, populaTabela]);
  useEffect(() => {
    getProdutos();
  }, [getProdutos]);
  useEffect(() => {
    if (addMontagem) {
      handleOpenInsertBaixaAdicionais();
      // setAddMontagem(false);
    }
  }, [addMontagem, handleOpenInsertBaixaAdicionais, setAddMontagem]);
  return (
    <Container onSubmit={handleSubmit} ref={formRef} id="formulario">
      {montagens
        .filter((m) => m.focus && m.cd != -1)
        .map((montagem) => (
          <TabMontagem>
            <Title>Montagem</Title>
            <TabMontagemTop>
              <div style={{ alignSelf: 'flex-start' }}>
                <InputLabel
                  id="select-label"
                  style={{ marginBottom: '4px', marginLeft: '2px' }}
                >
                  Nome
                </InputLabel>
                <Input
                  name="insumo_nm"
                  style={{ width: '250px' }}
                  placeholder="Nome"
                  defaultValue={montagem.nm == null ? '' : montagem.nm}
                  value={montagem.nm == null ? '' : montagem.nm}
                  onChange={(e) => changeMontagem(e.target.value, 'nome')}
                />
              </div>
              <div style={{ alignSelf: 'flex-start' }}>
                <InputLabel
                  id="select-label"
                  style={{ marginBottom: '4px', marginLeft: '2px' }}
                >
                  Título
                </InputLabel>
                <Input
                  name="insumo_titulo"
                  style={{ width: '250px' }}
                  placeholder="Título"
                  defaultValue={montagem.titulo == null ? '' : montagem.titulo}
                  value={montagem.titulo == null ? '' : montagem.titulo}
                  onChange={(e) => changeMontagem(e.target.value, 'titulo')}
                />
              </div>
            </TabMontagemTop>
            <TabMontagemBottom>
              <div style={{ alignSelf: 'flex-start' }}>
                <InputLabel
                  id="select-label"
                  style={{ marginBottom: '4px', marginLeft: '2px' }}
                >
                  Qtd Min.
                </InputLabel>
                <Input
                  style={{ width: '150px' }}
                  name="qtd"
                  placeholder="Qtd Min."
                  defaultValue={
                    montagem.qtd_min == null ? '' : montagem.qtd_min
                  }
                  value={montagem.qtd_min == null ? '' : montagem.qtd_min}
                  onChange={(e) => changeMontagem(e.target.value, 'qtd_min')}
                />
              </div>
              <div style={{ alignSelf: 'flex-start' }}>
                <InputLabel
                  id="select-label"
                  style={{ marginBottom: '4px', marginLeft: '2px' }}
                >
                  Qtd. Máx
                </InputLabel>
                <Input
                  style={{ width: '150px' }}
                  name="qtd"
                  placeholder="Qtd. Máx"
                  defaultValue={
                    montagem.qtd_max == null ? '' : montagem.qtd_max
                  }
                  value={montagem.qtd_max == null ? '' : montagem.qtd_max}
                  onChange={(e) => changeMontagem(e.target.value, 'qtd_max')}
                />
              </div>
              <div style={{ alignSelf: 'flex-start' }}>
                <InputLabel
                  id="select-label"
                  style={{ marginBottom: '4px', marginLeft: '2px' }}
                >
                  Ordem
                </InputLabel>
                <Input
                  style={{ width: '150px' }}
                  name="qtd"
                  placeholder="Ordem"
                  defaultValue={montagem.ordem == null ? '' : montagem.ordem}
                  value={montagem.ordem == null ? '' : montagem.ordem}
                  onChange={(e) => changeMontagem(e.target.value, 'ordem')}
                />
              </div>
            </TabMontagemBottom>
          </TabMontagem>
        ))}
      <Title>Insumos</Title>
      <TabAdicionais>
        <DataGrid
          columns={columns}
          rowGetter={(i) => filteredRows[i]}
          rowsCount={filteredRows.length}
          minHeight={150}
          toolbar={<Toolbar enableFilter filterRowsButtonText="Filtrar" />}
          onAddFilter={(filter) => setFilters(handleFilterChange(filter))}
          onClearFilters={() => setFilters({})}
          getCellActions={getCellActions}
          emptyRowsView={EmptyRowsView}
        />
        <div style={{ alignSelf: 'flex-start' }}>
          <MaterialButton
            onClick={handleOpenInsertBaixaAdicionais}
            style={{
              color: '#2c73e9',
            }}
          >
            INSERIR
          </MaterialButton>
        </div>
      </TabAdicionais>

      <DialogAdicionais
        listaProdutos={listaProdutos}
        open={openInsertBaixaAdicionais}
        populaTabela={populaTabela}
        setOpenInsertBaixaAdicionais={setOpenInsertBaixaAdicionais}
        setCdBaixaAdicional={setCdBaixaAdicional}
        cdBaixaAdicional={cdBaixaAdicional}
        typeRequest={typeRequest}
      />

      <DialogDeleteAdicionais
        open={openConfirmation}
        setOpen={setOpenConfirmation}
        cdBaixaAdicional={cdBaixaAdicionalDelete}
        populaTabela={populaTabela}
      />
    </Container>
  );
};

export default TabInsumos;
